import { render, staticRenderFns } from "./kv-field.vue?vue&type=template&id=94016090&scoped=true"
import script from "./kv-field.vue?vue&type=script&lang=js"
export * from "./kv-field.vue?vue&type=script&lang=js"
import style0 from "./kv-field.vue?vue&type=style&index=0&id=94016090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94016090",
  null
  
)

export default component.exports